<template>
  <div class="admin-sidebar dark-bg py-2 main">
    <h4 class>Divvy Admin Menu</h4>
    <div class="accordian" role="tablist">
      <ul class="nav flex-column mt-3">
        <li class="nav-item">
          <a class="nav-link" v-b-toggle.account href="#dashboard #top">
            Dashboard
          </a>
          <b-collapse id="account" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('dashboard')">
            <router-link
              class="nav-link"
              :to="{ name: 'divvyAdminDashboard', params: { activeMenuItem: 'divvyAdminDashboard' } }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('divvyAdminDashboard'),
              }"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Dashboard
            </router-link>
            <router-link
              class="nav-link"
              :to="{ name: 'divvyAdminSassFees', params: { activeMenuItem: 'divvyAdminSassFees' } }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('divvyAdminSassFees'),
              }"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Sass & Fees
            </router-link>
            <router-link
              class="nav-link"
              :to="{ name: 'divvyAdminLastLogin', params: { activeMenuItem: 'divvyAdminLastLogin' } }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('divvyAdminLastLogin'),
              }"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Last Login Report
            </router-link>
          </b-collapse>
        </li>
        <li class="nav-item" v-if="sidebarModules.some(({ module_action }) => module_action === 'Account')">
          <a class="nav-link" v-b-toggle.account href="#account #top">
            Account
          </a>
          <b-collapse id="account" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('account')">
            <router-link
              class="nav-link"
              :to="{ name: '', params: { activeMenuItem: 'accountPassword' } }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('accountPassword'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'ChangePassword')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Change Password
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: '',
                params: { activeMenuItem: 'accountLogout' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('accountLogout'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Logout')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Logout
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'DivvyAdminBreakageReport',
                params: { activeMenuItem: 'breakageReport'},
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('breakageReport'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'BreakageReport')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Breakage Report
            </router-link>
          </b-collapse>
        </li>
        <li class="nav-item" v-if="sidebarModules.some(({ module_action }) => module_action === 'Security')">
          <a class="nav-link" v-b-toggle.security href="#security #top">
            Security
          </a>
          <b-collapse id="security" :visible="isMenuMatched('security')" accordion="my-accordion" role="tabpanel">
            <router-link
              class="nav-link"
              :to="{
                name: 'DivvyAdminManageSecurityRoles',
                params: { activeMenuItem: 'manageRoles' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('manageRoles'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'ManageRoles')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Manage Roles</router-link
            >
            <router-link
              class="nav-link"
              :to="{
                name: 'ManageUsers',
                params: { activeMenuItem: 'manageUsers' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('manageUsers'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'ManageUsers')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Manage Users</router-link
            >
          </b-collapse>
        </li>
        <li class="nav-item" v-if="sidebarModules.some(({ module_action }) => module_action === 'UserClientManagement')">
          <a class="nav-link" v-b-toggle.clientusermanagement href="#clientusermanagement #top">
            User/Client Management
          </a>
          <b-collapse id="clientusermanagement" :visible="isMenuMatched('clientusermanagement')" accordion="my-accordion" role="tabpanel">
            <router-link
              class="nav-link"
              :to="{
                name: 'BusinessUnits',
                params: { activeMenuItem: 'businessUnits' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('businessUnits'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'BusinessUnits')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Business Units
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'ManageClients',
                params: { activeMenuItem: 'manageClients' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('manageClients'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Clients')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Clients
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'Customers',
                params: { activeMenuItem: 'customers' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('customers'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Customers')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Customers
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'Users',
                params: {
                  activeMenu: 'clientusermanagement',
                },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('usersmodule'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Users')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Users
            </router-link>
            <router-link
              class="nav-link"
              :to="{ name: 'clientAccountStatementConfiguration', params: { activeMenuItem: 'clientAccountStatementConfiguration' } }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('clientAccountStatementConfiguration'),
              }"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Client Account Statement
            </router-link>
          </b-collapse>
        </li>
        <li class="nav-item" v-if="sidebarModules.some(({ module_action }) => module_action === 'CRMTools')">
          <a class="nav-link" v-b-toggle.crm-tools href="#crm-tools #top">
            CRM Tools
          </a>
          <b-collapse id="crm-tools" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('crm-tools')">
            <router-link
              class="nav-link"
              :to="{
                name: 'BatchProcess',
                params: { activeMenuItem: 'batchProcess' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('batchProcess'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'BatchProcess')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Batch Process</router-link
            >
            <router-link
              class="nav-link"
              :to="{
                name: 'CustomerOrders',
                params: { activeMenuItem: 'customerOrders' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('customerOrders'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'CustomerOrders')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Customer Orders</router-link
            >
            <router-link
              class="nav-link"
              :to="{
                name: 'ShippingSearch',
                params: { activeMenuItem: 'shippingSearch' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('shippingSearch'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'ShippingSearch')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Shipping Search</router-link
            >
          </b-collapse>
        </li>

        <li class="nav-item" v-if="sidebarModules.some(({ module_action }) => module_action === 'ProductsSuppliers')">
          <a class="nav-link" v-b-toggle.productandsuppliers href="#productandsuppliers #top">
            Product & Suppliers
          </a>
          <b-collapse id="productandsuppliers" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('productandsuppliers')">
            <router-link
              class="nav-link"
              :to="{
                name: 'AddNewProduct',
                params: { activeMenuItem: 'addNewProduct' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('addNewProduct'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'AddNewProduct')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Add New Product
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'Categories',
                params: { activeMenuItem: 'Categories' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('categories'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Categories')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Categories
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'ExcludedKeywords',
                params: { activeMenuItem: 'ExcludedKeywords' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('excludedKeywords'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'ExcludedKeywords')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Excluded Keywords
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'ManageProducts',
                params: { activeMenuItem: 'manageProducts' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('manageProducts'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'SearchEditProducts')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Search/Edit Products
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'ManageSuppliers',
                params: { activeMenuItem: 'addSupplier' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('addSupplier'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'Suppliers')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Suppliers
            </router-link>
          </b-collapse>
        </li>
        <li v-if="sidebarModules.some(({ module_action }) => module_action === 'Utilities')">
          <a class="nav-link" v-b-toggle.utilities href="#utilities #top">
            Utilities
          </a>
          <b-collapse id="utilities" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('utilities')">
            <router-link
              class="nav-link"
              :to="{
                name: 'General',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('general'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'General')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              General
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'GeneralLookup',
                params: { activeMenuItem: 'GeneralLookup' },
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('generalLookup'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'GeneralLookup')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              General Lookup
            </router-link>
            <router-link
              class="nav-link"
              :to="{
                name: 'GeneralPreLogin',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('preLogin'),
              }"
              v-if="sidebarSubModules.some(({ sub_module_action }) => sub_module_action === 'PrecacheLogins')"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Precache Logins
            </router-link>
          </b-collapse>
        </li>
        <li>
          <a class="nav-link" v-b-toggle.prefundingAndInvoicing href="#prefundingAndInvoicing #top">
            Prefunding And Invoicing
          </a>
          <b-collapse id="prefundingAndInvoicing" accordion="my-accordion" role="tabpanel" :visible="isMenuMatched('prefundingAndInvoicing')">
            <!-- <router-link
              class="nav-link"
              :to="{
                name: 'Prefunding',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('prefunding'),
              }"
            >
              <font-awesome-icon
                class="mr-1 ml-2"
                icon="angle-right"
                transform="shrink-1"
              />
              Prefunding
            </router-link> -->
            <router-link
              class="nav-link"
              :to="{
                name: 'InvoicesAndTransactions',
              }"
              @click.native="scrollToTop"
              v-bind:class="{
                activeItem: isMenuItemMatched('invoicesAndTransactions'),
              }"
            >
              <font-awesome-icon class="mr-1 ml-2" icon="angle-right" transform="shrink-1" />
              Invoices And Transactions
            </router-link>
          </b-collapse>
        </li>
        <li><a class="nav-link" @click="$router.push({ path: 'nps-survey-history'})" href="javascript:void(0)">Nps Survey History</a></li>
        <li><a class="nav-link" @click="$router.push({ path: 'sales-tax-list'})" href="javascript:void(0)">Sales Tax List</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'divvyAdminSidebar',

  data() {
    return {
      ActiveItem: '',
    };
  },

  computed: {
    ...mapGetters({
      sidebarModules: 'getSidebarModules',
      sidebarSubModules: 'getSidebarSubModules',
    }),
  },

  methods: {
    isMenuItemMatched(menuItem) {
      return this.$store.getters['divvyAdminSidebar/getActiveItem'] === menuItem ? true : false;
    },
    isMenuMatched(menu) {
      return this.$store.getters['divvyAdminSidebar/getActiveMenu'] === menu ? true : false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    ...mapActions(['sidebarModules/fetchSidebarModules']),

    fetchModules() {
      this.$store.dispatch('fetchSidebarModules', {
        ishradmin: false,
      });
    },
  },
  created() {
    this.fetchModules();
  },
};
</script>

<style lang="scss" scoped>
.admin-sidebar {
  background-color: $gray-900;
  color: $white !important;
  min-height: 102vh;
  padding: 24px 0px 24px 0px;
  font-weight: 700;
  position: sticky;
  top: 80px;
  h4 {
    color: $white !important;
    padding: 12px 32px;
    &::after {
      display: none;
    }
  }
  a {
    padding: 18px 36px;
    color: $white;
    &:hover {
      background-color: transparentize($primary, 0.7%);
    }
  }
  // .router-link-active {
  //   background-color: $primary;
  // }
}
.main {
  overflow: auto;
  padding-bottom: 1px;
}
.main::-webkit-scrollbar {
  display: none;
}

.activeItem {
  background-color: $primary;
}
</style>
<style>
#app > div > div.container-fluid {
  position: relative;
  display: block;
}
</style>
